import ScorePreview from '../ScorePreview';
import AchievementsDetails from './components/AchievementsDetails';
import AssessmentDetails from './components/AssessmentDetails';
import TopicDetails from './components/TopicDetails';
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll';
import 'smooth-scroll/dist/smooth-scroll.polyfills';

export default {
    name: 'my-assessment',
    components: {
        ScorePreview,
        AssessmentDetails,
        TopicDetails,
        AchievementsDetails
    },
    props: [],
    data() {
        var modules = {
            assessment: 0,
            achievements: 1,
            topics: 2
        };

        return {
            userIsLoggedIn: false,
            questionnaire: {
                scoreDefinition: {}
            },
            topics: [],
            selectedTopic: null,
            visibleTopicId: null,
            isLoaded: false,
            modules: modules,
            selectedModule: null,
            clickData: {
                delay: 300,
                clicks: 0,
                timer: null
            },
            toggleDrawer: true
        }
    },

    watch: {
        '$route'(to, from) {
            if (from.params.id !== to.params.id) {
                this._loadTopics();
            }
        },

        'questionnaire'() {
            this._sycAppData();
        },

        'topics'() {
            this._sycAppData();
        }
    },

    computed: {
        assessmentIsNotStarted() {
            return this.isLoaded && this.topics.filter(function (topic) {
                if (topic.isStarted || topic.isCompleted) {
                    return topic;
                }
            }).length === 0;
        },

        assessmentIsInProgress() {
            return this.isLoaded && this.topics.filter(function (topic) {
                if (topic.isStarted || topic.isCompleted) {
                    return topic;
                }
            }).length;
        },

        assessmentIsCompleted() {
            return this.isLoaded && (this.topics.length == this.topics.filter(function (topic) {
                if (topic.isCompleted) {
                    return topic;
                }
            }).length);
        },

        assessmentIsSubmitted() {
            return this.isLoaded && this.$state.get('questionnaire').isSubmitted;
        },

        questionnaireScore() {
            return this.questionnaire.scoreDefinition ? (this.questionnaire.scoreDefinition.score || 0) : 0;
        },

        questionnaireScoreLabel() {
            return this.questionnaire.scoreDefinition ? (this.questionnaire.scoreDefinition.label || 'N/A') : 'N/A';
        },

        questionnaireScoreColor() {
            return this.questionnaire.scoreDefinition ? (this.questionnaire.scoreDefinition.color || '#000000') : '#000000';
        },

        questionnaireScoreDefinition() {
            return this.$scoreService.getDescriptionByScore(this.questionnaireScore);
        },

        goToFirstNonCompletedTopic() {
            let self = this;
            let result = "/"

            if (self.topics) {
                for (const [topic] of self.topics.entries()) {
                    if (topic.progress < 100) {
                        result = '/topic/' + topic.defTopic.orderNumber + '/' + topic.id;
                        break;
                    }
                }
            }

            return result;
        },
    },

    created() {
        this.smoothScroll = new SmoothScroll('a[href*="#"]');
    },

    mounted() {
        this.$state.set('loading', true);
        this._getUserLogin();
        this._loadTopics(true);
    },

    methods: {

        async _getUserLogin() {
            let self = this;

            await self.$authManager.getUser(function (user) {
                if (!user) {
                    self.userIsLoggedIn = false;
                } else {
                    self.userIsLoggedIn = true;
                }
            });
        },

        async _loadTopics(init) {
            let screenWidth = screen.width;
            let self = this;
            self.isLoaded = false;
            await self.$authManager.getUser(function (user) {
                self.$api.getQuestionnaire(user).then(function (questionnaire) {
                    self.topics = self._extendTopics(questionnaire.topics);
                    self.questionnaire = questionnaire;
                    self.questionnaire.topics = [];

                    if (screenWidth < 568 && init) {
                        self.topics.every(function (topic) {
                            if (topic.progress < 100) {
                                self._selectModule(self.modules.topics, function() { self._selectTopic(topic) });
                                return false;
                            }
                            return true;
                        });
                        if(!self.selectedTopic) {
                            self.selectedModule = self.modules.assessment;
                        }
                    } else {
                        self.selectedModule = self.modules.assessment;
                    }
                    self.$achievements.initialize(self, self.questionnaire, self.topics);
                });
            });
        },

        async _sycAppData() {
            let self = this;

            self.$state.set('topics', self.topics || []);
            self.$state.set('questionnaire', self.questionnaire || {});
            self.$state.set('loading', false);
            self.isLoaded = true;
        },

        _extendTopics(topics) {
            for (let topic of topics) {
                Object.assign(topic, { isSelected: false });
            }

            return topics;
        },

        _selectModule(module, callback) {
            let self = this;

            self._clickHandler(callback);

            self.selectedModule = module;

            self.toggleDrawer = true;
            if (window.outerWidth < 570) {
                self.smoothScroll.animateScroll(0);
            }
        },

        _selectTopic(currentTopic, dblClicked) {
            let self = this;

            self.selectedTopic = null;

            if (self.topics) {
                for (let topic of self.topics) {
                    if (currentTopic && topic.id === currentTopic.id) {
                        topic.isSelected = true;
                        self.selectedTopic = Object.assign({}, topic);
                    } else {
                        topic.isSelected = false;
                    }
                }
            }

            if (dblClicked && self.selectedTopic) {
                self.$router.push('/topic/' + self.selectedTopic.defTopic.orderNumber + '/' + self.selectedTopic.id);
            }
        },

        _getTopicProgress(topic) {
            return topic ? (topic.progress || 0) : 0
        },

        _getTopicScore(topic) {
            return Math.round(topic ? (topic.score || 0) : 0, 0);
        },

        _clickHandler(callback) {
            let self = this;

            self.clickData.clicks++;

            if (self.clickData.clicks === 1) {
                self.clickData.timer = setTimeout(function () {
                    self.clickData.clicks = 0
                }, self.clickData.delay);
                if (callback) {
                    callback(false);
                }
            } else {
                clearTimeout(self.clickData.timer);
                if (callback) {
                    callback(true);
                }
                self.clickData.clicks = 0;
            }
        }
    }
}
